import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { DEPARTMENTS, DEPARTMENT_ADD, DEPARTMENT_DELETE } from "./actionTypes";
import {
  apiError,
  getDepartments,
  departmentListSuccessful,
  departmentAddSuccessful,
} from "./actions";

// AUTH related methods
import {
  postAdd,
  getList,
  postEdit,
  postDelete,
} from "../../../helpers/Helper";
import swal from "sweetalert";

function* getDepartment() {
  try {
    const response = yield call(getList, "/masters/departments/", {});
    yield put(departmentListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}

//If user is login then dispatch redux action's are directly from here.
function* AddDepartment({ payload: { department } }) {
  try {
    if (department.id === "") {
      const response = yield call(postAdd, "/masters/departments/", {
        name: department.name,
      });

      if (response.status === 201) {
        swal("Your Department Added Successfully.!", {
          icon: "success",
          timer: 1500,
        });
        yield put(getDepartments());
      } else {
        swal("Sorry! Unable to Add Department. Please Try Again!", {
          icon: "error",
        });
      }

      yield put(departmentAddSuccessful(null));
    } else {
      const response = yield call(
        postEdit,
        "/masters/departments/" + department.id,
        {
          name: department.name,
          modifiedon: new Date(department.createdon),
        }
      );
      if (response.status === 200) {
        swal("Your Department Edited Successfully.!", {
          icon: "success",
          timer: 1500,
        });
        yield put(getDepartments());
      } else {
        swal("Sorry! Unable to edit Department. Please Try Again!", {
          icon: "error",
        });
      }
      yield put(departmentAddSuccessful(null));
    }
  } catch (error) {
    swal({
      title: "Your Department name already exists! ",
      icon: "error",
    });
    //yield put(apiError(error));
  }
}

function* DeleteDepartment(deptId) {
  try {
    const response = yield call(
      postDelete,
      "/masters/departments/" + deptId.payload.deptId
    );

    if (response.status === 204) {
      swal("Your Department has been deleted!", {
        icon: "success",
        timer: 1500,
      });
      yield put(getDepartments());
    } else {
      swal("Sorry! Your Department has been not deleted!", {
        icon: "error",
      });
    }
  } catch (error) {
    swal(error, {
      icon: "error",
    });

    //yield put(apiError(error));
  }
}

export function* watchgetDepartments() {
  yield takeEvery(DEPARTMENTS, getDepartment);
}
export function* watchDepartmentAdd() {
  yield takeEvery(DEPARTMENT_ADD, AddDepartment);
}

export function* watchDepartmentDelete() {
  yield takeEvery(DEPARTMENT_DELETE, DeleteDepartment);
}

function* DepartmentSaga() {
  yield all([
    fork(watchgetDepartments),
    fork(watchDepartmentAdd),
    fork(watchDepartmentDelete),
  ]);
}

export default DepartmentSaga;
